import { createStore } from '@stencil/store';

import { TrackingASCState } from '../interfaces/interface.asc-analytics';
import { getFromBrowserStorage, removeFromBrowserStorage, setFromBrowserStorage, writeStoreToBrowserStorage } from '../utils/utils.store';

const initialState: TrackingASCState = {
  customerContact: {
    trackingStarted: false,
    formNames: ['contactInfo', 'replacementVehicle'],
    fields: [],
  },
};

const { on, onChange, state, reset } = createStore(initialState);

const storeName = 'store.tracking-asc';
let isInitalized = false;

on('set', () => {
  if (isInitalized) {
    writeStoreToBrowserStorage(state, storeName);
  }
});

export const populateFromLocal = () => {
  setFromBrowserStorage(storeName, state);
};

export const getFromLocal = () => {
  return getFromBrowserStorage(storeName);
};

export const setInitialized = (initializedValue: boolean) => {
  isInitalized = initializedValue;
};

export const clearFromLocal = () => {
  setInitialized(false);
  removeFromBrowserStorage(storeName);
};

export { on, onChange, state, reset };
export default state;
